module.exports = __webpack_public_path__ + "static/img/251.61c0b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/251.jpg
// module id = FCDL
// module chunks = 0